import moment from "moment-timezone";

export const timeZoneCST = "America/Chicago";

export function todayCST (): moment.Moment {
    return moment().tz("America/Chicago");
}

export function todayCSTAsString (format = "MM/DD/YYYY"): string {
    return moment().tz("America/Chicago").format(format);
}

export function convertFromUtcStringToCstString (input: string, format = "MM/DD/YYYY hh:mm a"): string {
    return moment.utc(input).tz("America/Chicago").format(format);
}